/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Duration_MaxInputs */



/**
* | output |
* | --- |
* | "Duration too long" |
*
* @param {Qc_Fix_Duration_MaxInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_duration_max = /** @type {((inputs?: Qc_Fix_Duration_MaxInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Duration_MaxInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée trop longue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dauer zu lang")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata troppo lunga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком большая длительность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración demasiado larga")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("持续时间过长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示時間が長すぎます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि बहुत लंबी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração demasiado longa")
	return /** @type {LocalizedString} */ ("Duration too long")
});